import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

import { BehaviorSubject } from 'rxjs';
import { SessionStorageService, SessionStorage } from 'ngx-webstorage';

import { ConfigService } from 'services/config/config.service';
import { UserInfo, UserPersonnelGroupInfo } from './user.service.class';
import { RoutePaths } from 'routes/route.roles';
import { BaseRoleInfo, LoginResult } from 'services/auth/auth.service.class';
import { SystemRole } from 'modules/shared/roles';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    @SessionStorage(undefined, null) private _User!: UserInfo | null;

    UserSubject: BehaviorSubject<UserInfo | null> = new BehaviorSubject<UserInfo | null>(null);

    get User(): UserInfo | null {
        return this._User;
    }

    set User(_ui: UserInfo | null) {
        this._User = _ui;
        this.UserSubject.next(_ui);
    }

    constructor(
        private configSvc: ConfigService,
        private http: HttpClient,
        private storage: SessionStorageService,
        private router: Router,
        private sessionService: SessionStorageService
    ) {
        this.UserSubject.next(this._User);
    }

    // #region Clear User Service Call

    ClearUser(): void {
        this.User = null;
        this.sessionService.clear('_User');
    }

    // #endregion

    // #region Get User Personnel Group

    GetUserPersonnelGroup() {
        return this.http.get<UserPersonnelGroupInfo | null>(this.configSvc.hostAddress + `api/User/pgroup`);
    }

    // #endregion

    // #region Set User

    SetUser(user: UserInfo | LoginResult): void {
        this.User = { ...user } as UserInfo;
    }

    // #endregion

    // #region Set User Current Role

    // SetUserCurrentRole(role: BaseRoleInfo): void {
    //     if (this.User?.CurrentRole != null && role.RoleName === this.User.CurrentRole) {
    //         return;
    //     }

    //     // To trigger proper session storage, we need to create a new objec reference, rather than just updating our existing User object.
    //     const newUser: UserInfo = JSON.parse(JSON.stringify(this.User)) as UserInfo;

    //     // Update the current role field.
    //     newUser.CurrentRole = role.RoleName;

    //     // Now, persist it to session storage and then broadcast it for listeners.
    //     this.User = newUser;

    //     // Go to the home screen.
    //     this.router.navigate([`/${RoutePaths.Home}`]);
    // }

    // #endregion

    // #region Update AuthToken Service Call

    UpdateAuthToken(AuthToken: string): void {
        // If the authtoken has changed, update the user record.
        if (AuthToken !== this.User?.AuthToken) {
            // To trigger proper session storage, we need to create a new object reference, rather than just updating our
            // existing User object.
            const newUser: UserInfo = JSON.parse(JSON.stringify(this.User)) as UserInfo;

            // Update the AuthToken field
            newUser.AuthToken = AuthToken;

            // Now, persist it to session storage and then broadcast it for listeners
            this.User = newUser;
        }
    }

    // #endregion

    // #region Update Personnel Group

    UpdatePersonnelGroup(pgrp: string | null) {
        // If the personnel group has changed, update the user record.
        if (pgrp !== this.User?.PersonnelGroup) {
            const newUser: UserInfo = JSON.parse(JSON.stringify(this.User)) as UserInfo;

            // Update the field.
            newUser.PersonnelGroup = pgrp;

            // Persist to session storage and broadcast.
            this.User = newUser;
        }
    }

    // #endregion
}
